import * as API from "./Api";

export const registerCreator = (data) =>
  API.post("auth/register-creator", data);
export const registerBrand = (data) => API.post("auth/register-brand", data);
export const login = (data) => API.post("auth/login-user", data);
export const verifyOtp = (data) => API.post("auth/verify-otp", data);
export const socialLogin = (data) => API.post("auth/social-login", data);
export const logout = (token) => {
  API.setHeaderAuthorization(token);
  return API.post("auth/logout").finally(() => {
    API.setHeaderAuthorization(null);
  });
};